import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import PoweredBy from '@/components/PoweredBy/PoweredByView.vue';

import { get_token } from '@/router/index.js';
import engagenet from '@/assets/create_images/community.png';
import orcaa from '@/assets/create_images/orcaa.png';
import xverdict from '@/assets/create_images/case.png';
import workflows from '@/assets/create_images/project.png';
import analytics from '@/assets/create_images/proba_logo.png';
import complyon from '@/assets/create_images/company.png';

import CreateOrcaa from "@/components/CreateOrcaa/CreateOrcaa.vue";
import CreateProba from "@/components/CreateProba/CreateProba.vue";
import CreateEngagement from "@/components/CreateEngagement/CreateEngagement.vue";
import CreateVerification from "@/components/CreateVerification/CreateVerification.vue";
import CreateWorkflows from "@/components/CreateWorkflows/CreateWorkflows.vue";
import CreateCase from "@/components/CreateCase/CreateCase.vue";


export default {
  name: 'HomeView',
  components: {
    Sidebar,
    Navbar,
    PoweredBy,
    CreateOrcaa,
    CreateProba,
    CreateEngagement,
    CreateVerification,
    CreateWorkflows,
    CreateCase
  },
  data: () => ({
      is_workspace_collapsed: false,
      is_graph_collapsed: false,
      card_images: {
        engagenet: engagenet,
        orcaa: orcaa,
        xverdict: xverdict,
        complyon: complyon,
        workflows: workflows,
        analytics: analytics,
      },
      workspace_map: {
        orcaa: "Courses",
        analytics: "Programme",
        complyon: "Company",
        xverdict: "Case",
        workflows: "Project",
        icworkbook: "Community",
      },
    active_tab: "home",

    tabs: [
      { label: "Home", value: "home", icon: "bi bi-house" },
      { label: "Orcaa AI", value: "orcaa", icon: "bi bi-mortarboard-fill" },
      { label: "Proba Workflows", value: "workflows", icon: "bi bi-diagram-3" },
      { label: "ComplyOn", value: "complyon", icon: "bi bi-building" },
      { label: "X-Verdict", value: "xverdict", icon: "bi bi-balance-scale" },
      { label: "Proba Analytics", value: "analytics", icon: "bi bi-bar-chart" },
      { label: "EngageNet", value: "icworkbook", icon: "bi bi-journal-bookmark" },
    ],
  }),
  computed: {
    active_component() {
      return ({
        orcaa: "CreateOrcaa",
        analytics: "CreateProba",
        icworkbook: "CreateEngagement",
        xverdict: "CreateCase",
        workflows: "CreateWorkflows",
        complyon: "CreateVerification",
      })[this.active_tab];
    },

    is_demo_domain() {
    if (window.location.hostname === "demo.live.aic-one.com") return true;

    return window.location.hostname.includes("demo.live.aic-one.com");
    },

    wrapper_class() {
      return ({
        'page-wrapper-create': true,
        'page-wrapper-full': this.is_demo_domain,
        'domain-card-fix': this.is_demo_domain,
      });
    }
  },

  methods: {
    launch_and_open(tab) {
      const allowed = Object.keys(this.workspace_map);

      if (!allowed.includes(tab)) {
        console.error("Invalid tab:", tab);
        return;
      }
      const workspace_type = Reflect.get(this.workspace_map, tab);
      this.launch_workspace(workspace_type);
    },

    toggle_collapse(section) {
    if (section === 'workspace') {
      this.is_workspace_collapsed = !this.is_workspace_collapsed;
    } else if (section === 'graph') {
      this.is_graph_collapsed = !this.is_graph_collapsed;
    }
  },

  async launch_workspace(workspace) {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/create_workspace/`;
      const is_Demo = this.is_demo_domain;
      const token = is_Demo ? null : get_token();

      if (!is_Demo && !token) {
        return;
      }

      try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { "Authorization": `Token ${token}` } : {}),
          'X-Page-URL': window.location.href,
        },
        body: JSON.stringify({ workspace: workspace }),
      });
      const data = await response.json();
      if (response.ok) {
          window.location = data.redirect_url;
        } else {
          const msg = data?.message || "Service currently unavailable.";
          this.$notyf.error(msg);
        }

      } catch(error){
        this.$notyf.error(`Error: ${String(error)}`);
      }
    },
  }
}